{
  "scheduling": "การนัดหมาย",
  "date": "วันที่",
  "time": "เวลา",
  "duration": "ระยะเวลา",
  "provider": "แพทย์",
  "reason": "เหตุผล",
  "status": "สถานะ",
  "statusOptions": {
    "scheduled": "นัดหมายแล้ว",
    "confirmed": "ยืนยันแล้ว",
    "arrived": "มาถึงแล้ว",
    "checked-in": "ลงทะเบียนแล้ว",
    "in-progress": "กำลังดำเนินการ",
    "completed": "เสร็จสิ้น",
    "cancelled": "ยกเลิกแล้ว",
    "no-show": "ไม่มาตามนัด"
  },
  "coverageScope": {
    "panel": "กลุ่มผู้ป่วย",
    "unit": "หน่วย",
    "facility": "ทั้งสถานพยาบาล"
  },
  "coverageScopeDescription": {
    "panel": "เฉพาะกลุ่มผู้ป่วยของแพทย์ที่รับการคุ้มครองเท่านั้น",
    "unit": "หน่วยที่กำหนดให้แพทย์ที่รับการคุ้มครอง",
    "facility": "ทั้งสถานพยาบาล — โดยทั่วไปสำหรับการเตรียมแพทย์เวร"
  },
  "dayShort": {
    "0": "อา.",
    "1": "จ.",
    "2": "อ.",
    "3": "พ.",
    "4": "พฤ.",
    "5": "ศ.",
    "6": "ส."
  },
  "blockType": {
    "available": "ว่าง",
    "blocked": "ปิดกั้น"
  },
  "appointmentTypes": {
    "followUp": "ติดตามผล",
    "newPatient": "ผู้ป่วยใหม่",
    "consultation": "ปรึกษา",
    "procedure": "หัตถการ",
    "urgent": "เร่งด่วน",
    "wellnessCheck": "ตรวจสุขภาพ",
    "physical": "ตรวจร่างกาย",
    "telemedicine": "การรักษาทางไกล",
    "scheduleTemplate": "แม่แบบตาราง"
  },
  "pages": {
    "providerDirectory": {
      "title": "ทำเนียบแพทย์",
      "subtitle": "เรียกดูและค้นหาผู้ให้บริการทางการแพทย์",
      "search": {
        "namePlaceholder": "ค้นหาด้วยชื่อ...",
        "specialtyPlaceholder": "ค้นหาด้วยสาขา..."
      },
      "filters": {
        "facilityAriaLabel": "กรองตามสถานพยาบาล",
        "departmentAriaLabel": "กรองตามแผนก",
        "allFacilities": "ทุกสถานพยาบาล",
        "allDepartments": "ทุกแผนก"
      },
      "loading": "กำลังโหลดข้อมูลแพทย์...",
      "loadError": "ไม่สามารถโหลดทำเนียบแพทย์ได้",
      "empty": "ไม่พบแพทย์ที่ตรงกับเงื่อนไขของคุณ",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "สร้างแม่แบบตารางเวร",
      "labels": {
        "provider": "แพทย์",
        "dayOfWeek": "วันในสัปดาห์",
        "startTime": "เวลาเริ่มต้น",
        "endTime": "เวลาสิ้นสุด",
        "slotDuration": "ความยาวช่วงเวลา (นาที)",
        "templateName": "ชื่อเทมเพลต",
        "effectiveStartDate": "มีผลตั้งแต่"
      },
      "slotDurationOption": "{{minutes}} นาที",
      "buttons": {
        "cancel": "ยกเลิก",
        "save": "บันทึกแม่แบบ"
      },
      "toast": {
        "success": "บันทึกแม่แบบตารางเวรแล้ว",
        "failure": "บันทึกแม่แบบตารางเวรไม่สำเร็จ"
      },
      "placeholders": {
        "templateName": "เช่น คลินิกเช้าวันจันทร์"
      },
      "defaultName": "ตารางเวลา {{day}}"
    },
    "scheduleManagement": {
      "title": "การจัดการตารางเวร",
      "backToDashboard": "← แดชบอร์ด",
      "newTemplate": "แม่แบบใหม่",
      "today": "วันนี้",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "ช่วงเวลา {{minutes}} นาที",
      "legend": {
        "booked": "จองแล้ว"
      },
      "upcomingAppointmentsHeading": "การนัดหมายที่จะมาถึง - {{providerName}}",
      "loadingAppointments": "กำลังโหลดการนัดหมาย...",
      "unknownPatient": "ผู้ป่วยที่ไม่รู้จัก",
      "fallbackAppointmentType": "ทั่วไป",
      "noUpcomingAppointments": "ไม่มีการนัดหมายที่จะมาถึงสำหรับแพทย์ท่านนี้"
    },
    "providerCoverage": {
      "title": "การปฏิบัติงานแทนของแพทย์",
      "subtitle": "การปฏิบัติงานแทนช่วงเวลาจำกัด — มอบกลุ่มผู้ป่วยของคุณให้เพื่อนร่วมงานในช่วงเวลาที่กำหนด แตกต่างจากการเข้าถึงฉุกเฉิน ใช้สำหรับการลาพักร้อน การหมุนเวียนเวร และการขาดงานตามแผน",
      "actions": {
        "newCoverage": "การปฏิบัติงานแทนใหม่",
        "cancel": "ยกเลิก"
      },
      "form": {
        "title": "ข้อตกลงการปฏิบัติงานแทนใหม่",
        "labels": {
          "coveredProviderId": "แพทย์ที่ได้รับการปฏิบัติแทน",
          "coveringProviderId": "แพทย์ที่ปฏิบัติแทน",
          "scope": "ขอบเขต",
          "from": "ตั้งแต่",
          "until": "ถึง",
          "reason": "เหตุผล"
        },
        "placeholders": {
          "coveredProviderId": "แพทย์ที่กลุ่มผู้ป่วยได้รับการคุ้มครอง",
          "coveringProviderId": "แพทย์ที่รับช่วงในช่วงเวลานี้",
          "reason": "เช่น ลาพักร้อน 22–29 เม.ย.; ปฏิบัติแทนเวรสุดสัปดาห์"
        },
        "help": {
          "coveredProviderId": "หากไม่มี COVERAGE_ADMIN ต้องเป็นตัวคุณเอง",
          "coveringProviderId": "ค้นหาตามชื่อแล้วเลือก — จะไม่มอบหมายการปฏิบัติแทนให้รหัสที่พิมพ์เอง"
        },
        "aria": {
          "effectiveFromDate": "วันที่เริ่มมีผล",
          "effectiveFromTime": "เวลาเริ่มมีผล",
          "effectiveUntilDate": "วันที่สิ้นสุดผล",
          "effectiveUntilTime": "เวลาสิ้นสุดผล"
        },
        "buttons": {
          "cancel": "ยกเลิก",
          "create": "สร้างการปฏิบัติงานแทน"
        },
        "typeaheadEmpty": "ไม่พบแพทย์"
      },
      "sections": {
        "mine": {
          "title": "การปฏิบัติงานแทนของฉัน",
          "subtitle": "การปฏิบัติงานแทนที่ฉันเป็นผู้ปฏิบัติแทนหรือผู้ที่ได้รับการปฏิบัติแทน",
          "empty": "ไม่มีการปฏิบัติงานแทนในบันทึก"
        },
        "all": {
          "title": "การปฏิบัติงานแทนทั้งหมด",
          "subtitle": "ทุกข้อตกลงการปฏิบัติงานแทนในองค์กร มุมมองผู้ดูแลระบบ",
          "empty": "ไม่มีการปฏิบัติงานแทนที่ใดเลย ข่าวดีมากหรือฟิลเตอร์เก่า"
        }
      },
      "list": {
        "coveringConnector": "ปฏิบัติแทน",
        "groups": {
          "active": "ใช้งานอยู่ ({{count}})",
          "planned": "ตามแผน / ที่ผ่านมา ({{count}})",
          "revoked": "ยกเลิก ({{count}})"
        },
        "untilRevoked": "จนกว่าจะยกเลิก",
        "revokedPrefix": "ยกเลิก",
        "revokeTitle": "ยกเลิก"
      },
      "revokeDialog": {
        "title": "ยกเลิกการปฏิบัติงานแทน?",
        "description": "{{coveringProviderName}} จะไม่ปฏิบัติแทน {{coveredProviderName}} อีกต่อไป บันทึกยังคงอยู่ในเส้นทางการตรวจสอบ",
        "confirm": "ยกเลิก",
        "reasonPlaceholder": "เหตุใดจึงยกเลิกการแทนนี้ (ไม่บังคับ)"
      },
      "toast": {
        "created": "สร้างการปฏิบัติงานแทนแล้ว",
        "revoked": "ยกเลิกการปฏิบัติงานแทนแล้ว",
        "invalid": "การปฏิบัติงานแทนไม่ถูกต้อง — ตรวจสอบแพทย์และวันที่",
        "forbidden": "ไม่ได้รับอนุญาตให้สร้างการปฏิบัติงานแทนสำหรับแพทย์นี้",
        "createFailed": "ไม่สามารถสร้างการปฏิบัติงานแทนได้",
        "revokeFailed": "ไม่สามารถยกเลิกการปฏิบัติงานแทนได้"
      }
    },
    "appointments": {
      "title": "การนัดหมาย",
      "subtitle": "จัดตารางและจัดการการนัดหมายของผู้ป่วย",
      "actions": {
        "refresh": "รีเฟรช",
        "schedule": "นัดหมาย",
        "arriveTitle": "บันทึกการมาถึง",
        "arriveAria": "บันทึกการมาถึงของ {{patientName}}",
        "checkInTitle": "ลงทะเบียน",
        "checkInAria": "ลงทะเบียน {{patientName}}",
        "rescheduleTitle": "เปลี่ยนนัดหมาย",
        "rescheduleAria": "เปลี่ยนนัดหมาย {{patientName}}",
        "cancelTitle": "ยกเลิก",
        "cancelAria": "ยกเลิกนัดหมายของ {{patientName}}",
        "checkedInLabel": "ลงทะเบียนแล้ว",
        "startVisitTitle": "เริ่มการตรวจ",
        "startVisitAria": "เริ่มการตรวจสำหรับ {{patientName}}"
      },
      "weekNav": {
        "previous": "สัปดาห์ก่อน",
        "previousAria": "สัปดาห์ก่อน",
        "next": "สัปดาห์ถัดไป",
        "nextAria": "สัปดาห์ถัดไป"
      },
      "calendar": {
        "gridAria": "ปฏิทินนัดหมายรายสัปดาห์",
        "timeColumn": "เวลา",
        "loading": "กำลังโหลดตาราง...",
        "cellAria": "{{dayLabel}} {{date}} เวลา {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "นัดหมายที่กำลังจะถึง",
        "empty": "ไม่พบนัดหมายในสัปดาห์นี้",
        "durationMinutes": "{{minutes}} นาที",
        "columns": {
          "dateTime": "วันที่ / เวลา",
          "patient": "ผู้ป่วย",
          "type": "ประเภท",
          "provider": "แพทย์",
          "duration": "ระยะเวลา",
          "status": "สถานะ",
          "actions": "การดำเนินการ"
        }
      },
      "toast": {
        "cancelled": "ยกเลิกนัดหมายแล้ว",
        "cancelFailed": "ไม่สามารถยกเลิกนัดหมายได้",
        "visitStarted": "เริ่มการตรวจแล้ว",
        "startVisitFailed": "ไม่สามารถเริ่มการตรวจได้",
        "arrivalRecorded": "บันทึกการมาถึงแล้ว",
        "arrivalFailed": "ไม่สามารถบันทึกการมาถึงได้"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "นัดหมายใหม่",
        "edit": "เปลี่ยนนัดหมาย"
      },
      "labels": {
        "patient": "ผู้ป่วย",
        "appointmentType": "ประเภทการนัดหมาย",
        "provider": "แพทย์ผู้ดูแล",
        "scheduledAt": "เวลานัดหมาย",
        "duration": "ระยะเวลา",
        "reason": "เหตุผลในการมาพบแพทย์"
      },
      "placeholders": {
        "patientSearch": "ค้นหาผู้ป่วยตามชื่อหรือ MRN...",
        "provider": "ชื่อแพทย์",
        "reason": "เหตุผลในการมาพบแพทย์โดยย่อ..."
      },
      "patientTypeahead": {
        "empty": "ไม่พบผู้ป่วย"
      },
      "aria": {
        "appointmentDate": "วันที่นัดหมาย",
        "appointmentTime": "เวลานัดหมาย"
      },
      "durationOption": "{{minutes}} นาที",
      "buttons": {
        "cancel": "ยกเลิก",
        "schedule": "จองนัดหมาย",
        "update": "อัปเดตนัดหมาย"
      },
      "toast": {
        "created": "สร้างนัดหมายสำเร็จ",
        "updated": "อัปเดตนัดหมายแล้ว",
        "createFailed": "สร้างนัดหมายล้มเหลว",
        "updateFailed": "อัปเดตนัดหมายล้มเหลว"
      },
      "validation": {
        "patientRequired": "กรุณาเลือกผู้ป่วย",
        "appointmentTypeRequired": "ต้องระบุประเภทการนัดหมาย",
        "scheduledAtRequired": "กรุณาระบุวันและเวลา",
        "durationInvalid": "ระยะเวลาต้องอยู่ระหว่าง 1 ถึง 480 นาที",
        "providerRequired": "กรุณาเลือกแพทย์"
      },
      "providerTypeahead": {
        "empty": "ไม่พบแพทย์"
      },
      "loadingEdit": "กำลังโหลดนัดหมาย…",
      "loadEditError": "ไม่สามารถโหลดนัดหมายนี้ได้",
      "patientLocked": "ไม่สามารถเปลี่ยนผู้ป่วยเมื่อเลื่อนนัดหมาย"
    },
    "waitlist": {
      "title": "รายการรอการนัดหมาย",
      "backToDashboard": "← แดชบอร์ด",
      "entryCount": "{{count}} รายการ",
      "searchPlaceholder": "ค้นหาด้วยชื่อผู้ป่วย MRN หรือบันทึก...",
      "clearSearchAria": "ล้างการค้นหา",
      "filters": {
        "allProviders": "แพทย์ทุกคน",
        "allTypes": "ทุกประเภท",
        "providerAriaLabel": "กรองตามแพทย์",
        "typeAriaLabel": "กรองตามประเภทการนัดหมาย"
      },
      "columns": {
        "patient": "ผู้ป่วย",
        "provider": "แพทย์",
        "type": "ประเภท",
        "priority": "ระดับความสำคัญ",
        "requestedDates": "วันที่ขอ",
        "dateAdded": "วันที่เพิ่ม",
        "notes": "บันทึก",
        "actions": "การดำเนินการ",
        "reason": "เหตุผล"
      },
      "priority": {
        "urgent": "ด่วน",
        "routine": "ปกติ",
        "flexible": "ยืดหยุ่น"
      },
      "actions": {
        "scheduleTitle": "นัดหมาย",
        "editPriorityTitle": "แก้ไขระดับความสำคัญ",
        "removeTitle": "ลบออกจากรายการรอ"
      },
      "empty": "ไม่มีรายการรอที่ตรงกับตัวกรองของคุณ",
      "loadFailed": "ไม่สามารถโหลดรายการรอได้ โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
      "modal": {
        "title": "นัดหมาย",
        "closeAria": "ปิด",
        "providerLabel": "แพทย์:",
        "requestedLabel": "ขอ:",
        "dateTimeLabel": "วันและเวลานัดหมาย *",
        "dateAria": "วันนัดหมาย",
        "timeAria": "เวลานัดหมาย",
        "requestedWindow": "ช่วงเวลาที่ขอ: {{start}} — {{end}}",
        "cancel": "ยกเลิก",
        "submit": "นัดหมาย"
      },
      "toasts": {
        "removed": "ลบออกจากรายการรอแล้ว",
        "priorityUpdated": "อัปเดตระดับความสำคัญแล้ว",
        "scheduled": "นัดหมายเรียบร้อยและลบออกจากรายการรอแล้ว",
        "dateTimeRequired": "กรุณาเลือกวันและเวลา",
        "updateFailed": "อัปเดตรายการรอไม่สำเร็จ",
        "promoteOrphaned": "สร้างนัดหมายแล้ว แต่ไม่สามารถอัปเดตรายการรอได้ โปรดตรวจสอบตารางนัดก่อนลองอีกครั้ง"
      }
    },
    "checkIn": {
      "title": "ลงทะเบียนผู้ป่วย",
      "subtitle": "การลงทะเบียน — ประกัน การอนุมัติ และค่าร่วมจ่าย ผู้ป่วยมาถึงแล้ว",
      "fields": {
        "insuranceId": "ประกัน",
        "copayAmount": "จำนวนค่าร่วมจ่าย",
        "copayCollected": "รับค่าร่วมจ่ายแล้ว",
        "authorizationNumber": "เลขที่การอนุมัติ",
        "authorizationVerified": "ยืนยันการอนุมัติแล้ว"
      },
      "copayHint": "การทำเครื่องหมายว่ารับค่าร่วมจ่ายแล้วจะบันทึกการชำระเงินเข้าบัญชีผู้ป่วย",
      "submit": "เสร็จสิ้นการลงทะเบียน",
      "cancel": "ยกเลิก",
      "toast": {
        "success": "ลงทะเบียนผู้ป่วยแล้ว",
        "failed": "ไม่สามารถลงทะเบียนผู้ป่วยได้"
      }
    },
    "providerTypeahead": {
      "loadError": "ไม่สามารถใช้ไดเรกทอรีแพทย์ได้ — โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
      "retry": "ลองอีกครั้ง"
    }
  }
}
